import ClientsSection from "@/components/ClientsSection";
import CTASection from "@/components/CTASection";
import FinalCTA from "@/components/FinalCTA";
import FusionConceptSection from "@/components/FusionConceptSection";
import PlatformSection from "@/components/PlatformSection";
import AILabSection from "@/components/AILabSection";
import CreationDeskSection from "@/components/CreationDeskSection";

import Hero from "@/components/Hero";
import MessyMiddleSection from "@/components/MessyMiddleSection";
import Navigation from "@/components/Navigation";
import SolutionPricingSection from "@/components/SolutionPricingSection";

import SkillsSection from "@/components/SkillsSection";
import FooterWithNewsletter from "@/components/ui/footer-column";

import { useEffect } from "react";

const Index = () => {
  useEffect(() => {
    const handleScrollToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const targetId = hash.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };

    setTimeout(handleScrollToHash, 100);
  }, []);
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <MessyMiddleSection />
      <FusionConceptSection />
      <PlatformSection />
      <AILabSection />
      <CreationDeskSection />
      <CTASection />
    
      <div id="pricing">
        <SolutionPricingSection />
      </div>
      <SkillsSection />
      <ClientsSection />
      <FinalCTA />
      <FooterWithNewsletter />
    </div>
  );
};

export default Index;
